<template>
  <div>
    <ActionBar>
      <ActionBarTitle>บันทึกรายรับ รายจ่าย</ActionBarTitle>
      <el-button v-if="this.isAdmin " slot="action" type="success" icon="el-icon-plus" @click="createIncome">
        รายรับ
      </el-button>
      <el-button v-if="this.isAdmin " slot="action" type="danger" icon="el-icon-plus" @click="createExpense">
        รายจ่าย
      </el-button>
    </ActionBar>

    <PageContainer>
      <AppContainer>
        <Overview />
        <SearchBar style="margin-top:1.5rem" @submit="filter" />
        <Result ref="result" style="margin-top:1.5rem" />
      </AppContainer>
    </PageContainer>
  </div>
</template>

<script>

import {
  ActionBar,
  ActionBarTitle,
  //ActionBarButton
} from '@/components/ui/action-bar'
import { PageContainer } from '@/components/page/page-container'
import { AppContainer } from '@/components/ui/container'
import { mapGetters } from 'vuex'

const Overview = () => import('./Overview.vue')
const SearchBar = () => import('./Filter.vue')
const Result = () => import('./Result.vue')

export default {
  components: {
    ActionBar,
    ActionBarTitle,
    //ActionBarButton,
    Overview,
    SearchBar,
    Result,
    PageContainer,
    AppContainer
  },
  computed: {
    ...mapGetters('auth', ['isAdmin'])
  },
  methods: {
    filter() {
      this.$refs.result.reset()
      this.$refs.result.fetch()
      if (this.$route.query.start && this.$route.query.end)
        this.$refs.result.fetchOverview()
    },
    createIncome() {
      this.$router.push({ name: 'IncomeExpenseIncomeCreate' })
    },

    createExpense() {
      this.$router.push({ name: 'IncomeExpenseExpenseCreate' })
    }
  },

  /*
  render() {
    return (
      <div>
        <ActionBar>
          {this.isAdmin && [
            <ActionBarButton
              slot="action"
              type="success"
              icon="el-icon-plus"
              onClick={this.createIncome}
            >
              รายรับ
            </ActionBarButton>,
            <ActionBarButton
              slot="action"
              type="danger"
              icon="el-icon-plus"
              onClick={this.createExpense}
            >
              รายจ่าย
            </ActionBarButton>
          ]}
          <ActionBarTitle>บันทึกรายรับ รายจ่าย</ActionBarTitle>
        </ActionBar>
        <PageContainer>
          <AppContainer>
            <Overview />
            <Filter style={{ marginTop: '1.5rem' }} onSubmit={this.filter} />
            <Result
              ref="result"
              style={{ marginTop: '1.5rem' }}
              onPageChange={this.changePage}
            />
          </AppContainer>
        </PageContainer>
      </div>
    )
  } */
}
</script>
